import { render, staticRenderFns } from "./LaboratoryCCActions.vue?vue&type=template&id=1fae6a71"
import script from "./LaboratoryCCActions.vue?vue&type=script&lang=js"
export * from "./LaboratoryCCActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports